import { Form } from "devextreme-react/form";
import { GroupItem, SimpleItem } from "devextreme-react/form";
import React, { forwardRef } from "react"
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { imageUrl } from "../../services/urls";
import { renderInformationItem } from "../productRequestPage/detail";
import { Slider } from "./type"



const SliderDetail = forwardRef<any, { data: Slider }>(
    ({ data }, ref) => {
        const localize = useSelector(getLocalized);
        return (
            <form>
                <Form
                    ref={ref}
                    key="id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                >
                    <GroupItem colCount={1}>
                        <GroupItem colCount={1}>

                            <SimpleItem

                                render={() => {
                                    return <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    ><img src={imageUrl + data.Path} style={{
                                        maxWidth: "1100px",
                                        width: "100%"
                                    }} alt=""></img></div>

                                }}
                            >

                            </SimpleItem>
                        </GroupItem>
                        <GroupItem>
                            <SimpleItem
                                dataField="Title"
                                label={{
                                    text: localize.getString("title"),
                                }}
                                render={renderInformationItem}
                            />
                            <SimpleItem
                                dataField="Description"
                                label={{
                                    text: localize.getString("description"),
                                }}
                                render={renderInformationItem}
                            />
                            <SimpleItem
                                dataField="Message"
                                label={{
                                    text: localize.getString("message"),
                                }}
                                render={renderInformationItem}
                            />
                            <SimpleItem
                                dataField="ProductCategoryName"
                                label={{
                                    text: localize.getString("category"),
                                }}
                                render={renderInformationItem}
                            />

                        </GroupItem>
                    </GroupItem>
                </Form>
            </form>
        );
    }
)

export default SliderDetail